import React from "react";
import TabButton from "../TabButton/index.jsx";

const TabNav = ({ tabs, onTabClick, activeTab, keyColor }) => {
  return (
    <div className="tab-nav">
      {Object.keys(tabs).map(key => {
        return (
          <TabButton
            key={key}
            isActive={key === activeTab}
            keyColor={keyColor}
            onClick={onTabClick(key)}
          >
            {tabs[key]}
          </TabButton>
        );
      })}
    </div>
  );
};

export default TabNav;
